//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
let d=[[[0,"CreateAllProfilesSketch",1,0],[0,"CreateNewBooklet",1,0],[0,"RelatedBooklets",1,0],[0,"SelectedBookletItem",1,0]],[[["part"],"AddSelectedProfile",{},1,0],[[],"ClearSelectedProfile",{},0,0],[["part","distanceTolerance"],"SetSelectedProfileIBLSpacing",{},2,0]],[]];
SPLM.Features.ShipDesign.ProfileSketchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ProfileSketchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ProfileSketchBuilder.EditMode = Object.freeze({
    "AllProfiles" : "AllProfiles", "SelectProfiles" : "SelectProfiles", "UpdatedProfiles" : "UpdatedProfiles", "InverseBentProfiles" : "InverseBentProfiles"});

export default SPLM;